import { IProductDto } from 'api/products/dto';
import { ProductStructure } from 'constants/enums/products';

export const calculateSectionPrice = (
  items: IProductDto[],
  productStructure: ProductStructure.BundleProduct | ProductStructure.SingleProduct
) => {
  if (!items?.length) return 0;

  if (productStructure === ProductStructure.SingleProduct) {
    return items?.reduce((sum, product) => sum + (product.discountedPrice ?? 0) * (product.quantity ?? 0), 0);
  } else {
    return items?.reduce((sum, product) => sum + (product.discountedPrice ?? 0), 0);
  }
};
